import { Backdrop as MuiBackdrop, CircularProgress } from '@mui/material';

export const Backdrop = ({ isLoading }: { isLoading: boolean }) => (
    <MuiBackdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
    </MuiBackdrop>
);
